import { FullGestureState } from "react-use-gesture/dist/types";
import { RectReadOnly } from "react-use-measure";
import { pipe, Subject, interval, of, Observable, combineLatest } from "rxjs";
import {
  combineLatestWith,
  distinctUntilChanged,
  filter,
  map,
  scan,
} from "rxjs/operators";
import { Note } from "../../state/data";
import { notesQuery } from "../../state/state/store";
import { destinations$ } from "./Placeholder";

const logob = (label, $money) =>
  $money.subscribe({
    next: (e) => console.log(label, " ~~ ", e),
  });

export type DraggingEvent = {
  type: "DRAGGING";
  gevent: FullGestureState<"drag">;
  startingPosition: DOMRect;
} & { id: string };

export type DragEndEvent = { type: "DRAG_END" } & { id: string };

export type DragStartEvent = {
  type: "DRAG_START";
  position: DOMRect;
  id: string;
};

export type DoneAnimatingEvent = { type: "DONE_ANIMATING" } & { id: string };

export type DragEvent =
  | DragStartEvent
  | DraggingEvent
  | DragEndEvent
  | DoneAnimatingEvent;

export const drag$ = new Subject<DragEvent>();
export const placeholderDimensions$ = new Subject<{
  width: number;
  height: number;
}>();

// drag$.subscribe({ next: (e) => console.log("dragggggg", e) });

export const draggingEvents$ = drag$.pipe(
  filter((e): e is DraggingEvent => e.type === "DRAGGING")
);

export const dragStarts$ = drag$.pipe(
  filter((e): e is DragStartEvent => e.type === "DRAG_START")
);

export const dragEnds$ = drag$.pipe(
  filter((e): e is DragEndEvent => e.type === "DRAG_END")
);

export const animationEndings$ = drag$.pipe(
  filter((e): e is DoneAnimatingEvent => e.type === "DONE_ANIMATING")
);

export const isDragging$ = drag$.pipe(
  scan((acc, e) => {
    switch (e.type) {
      case "DRAG_START":
        return acc + 1;
      case "DRAG_END":
        return acc - 1;
      default:
        return acc;
    }
  }, 0),
  map((n) => n > 0),
  distinctUntilChanged()
);

export const isAnimating$ = drag$.pipe(
  scan((acc, e) => {
    switch (e.type) {
      case "DRAG_END":
        return acc + 1;
      case "DONE_ANIMATING":
        return acc - 1;
      default:
        return acc;
    }
  }, 0),
  map((n) => n > 0),
  distinctUntilChanged()
);

export const isDraggingOrAnimating$ = drag$.pipe(
  scan((acc, e) => {
    switch (e.type) {
      case "DRAG_START":
        return acc + 1;
      case "DONE_ANIMATING":
        return acc - 1;
      default:
        return acc;
    }
  }, 0),
  map((n) => n > 0),
  distinctUntilChanged()
);

export const ongoingDrag$: Observable<DragStartEvent | undefined> =
  combineLatest([dragStarts$, isDragging$]).pipe(
    map(([start, isDragging]) => (isDragging ? start : undefined))
  );

export const draggedNote$: Observable<Note | undefined> = ongoingDrag$.pipe(
  map((ongoingDrag) =>
    ongoingDrag === undefined ? undefined : notesQuery.getEntity(ongoingDrag.id)
  )
);

export const hasNoDestination$: Observable<boolean> = combineLatest([
  draggingEvents$,
  destinations$,
]).pipe(
  map(([dragging, destination]) => {
    return destination.clientHeight === 0;
  }),
  distinctUntilChanged()
);

export const lastDraggedNoteId$ = drag$.pipe(
  filter((e): e is DraggingEvent => e.type === "DRAGGING"),
  map((e) => e.id),
  distinctUntilChanged()
);

/* styling cursor */
dragStarts$.subscribe({
  next: (e) => {
    document.getElementById("root")!.style.cursor = "grabbing";
    document.getElementById("root")!.style.userSelect = "none";
  },
});

dragEnds$.subscribe({
  next: (e) => {
    document.getElementById("root")!.style.cursor = "initial";
    document.getElementById("root")!.style.userSelect = "initial";
  },
});
